
import '../../Pages/Expert/AO/ListAOs.scss';

import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { dureeMissionFiltre } from '../../data/Interfaces';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useWindowSize from '../../hooks/useWindowSize';
import { buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
import { DatePickerComponent, SelectComponent, TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';
function AoAdvancedSearchDialog({ setAos, setNumberOfPages, openAdvancedAoSearch, handleCLoseAdvancedAOSearch }) {
    AoAdvancedSearchDialog.propTypes = {
        openAdvancedAoSearch: PropTypes.any,
        handleCLoseAdvancedAOSearch: PropTypes.func,
        setAos: PropTypes.func,
        setNumberOfPages: PropTypes.func,
    };
    const axiosPrivate = useAxiosPrivate();
    const {device}=useWindowSize();
    const [dateDebutMission, setDateDebutMission] = useState('');
    const [datePublication, setDatePublication] = useState('');
    const [intitulePoste, setIntitulePoste] = useState('');
    const { i18n } = useTranslation();
    const [aoId, setAoId] = useState('');
    const [tjMax, setTjMax] = useState('');
    const [dureeMission, setDureeMission] = useState('');
    const [entrepriseName, SetEntrepriseName] = useState('');

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };
    const handleAdvancedSearchAO = async () => {
        try {
            const response = await axiosPrivate.post('/ao/advancedSearchAO',
                {
                    intitulePoste,
                    aoId,
                    tjMax,
                    dureeMission,
                    entrepriseName,
                    dateDebutMission,
                    datePublication
                }
            );
            // const responseData1 = await response1.data;
            console.log('response.data?.AOs', response.data?.AOs);
            setAos(response.data?.AOs);
            // setAosOrigine(response.data?.AOs);
            setNumberOfPages(response.data?.totalPages);
        } catch (error) {
            console.log(error.response?.status);
        }
    };

    return (
        <Dialog
            open={openAdvancedAoSearch}
            onClose={handleCLoseAdvancedAOSearch}
            TransitionComponent={Transition}
            fullScreen
            PaperProps={{
                style: {
                    background: '#FFFFFF',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCLoseAdvancedAOSearch}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <form style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', minHeight: '900px', height: '100%', paddingBottom: '24px' }}>
                <div className='Box1Filter'>
                    <div className='f11'>
                        <h4 className=''>
                            {i18n.t('Filtres')}
                        </h4>
                        <p className='Titlef11'>
                            {i18n.t('Intitulé de poste')}
                        </p>
                        <TextFieldComponent
                            className="In1"
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            style={{width: '100%'}}
                            placeholder={i18n.t('Rechercher un poste')}
                            value={intitulePoste}
                            onChange={(event) => { setIntitulePoste(event.target.value); }}
                        />
                    </div>
                    <div className='f12'>
                        <p className='Titlef11'>
                            {i18n.t('Référence')}
                        </p>
                        <TextFieldComponent
                            className="In1"
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            style={{width: '100%'}}
                            placeholder={i18n.t('Rechercher une référence')}
                            value={aoId}
                            onChange={(event) => { setAoId(event.target.value); }}
                        />
                    </div>
                    <div className='f2'>
                        <p className='Titlef11'>
                            {i18n.t('TJM (€)')}
                        </p>
                        <TextFieldComponent
                            className="In1"
                            type='number'
                            sx={{
                                '& > :not(style)': {borderRadius: '8px' },
                            }}
                            style={{width: '100%'}}
                            placeholder={i18n.t('Ajouter un TJM')}
                            onKeyDown={handleKeyDown}
                            InputProps={{
                                inputProps: { min: 0,}
                            }}
                            value={tjMax}
                            onChange={(event) => { setTjMax(event.target.value); }}
                        />
                    </div>
                    <div className='f3'>
                        <p className='Titlef11'>
                            {i18n.t('Durée minimum de la mission')}
                        </p>
                        <SelectComponent
                            setVal={(e) => {
                                setDureeMission(e.target.value);
                            }}
                            val={dureeMission}
                            listVal={dureeMissionFiltre}
                        />
                    </div>
                    <div className='f4'>
                        <p className='Titlef11'>
                            {i18n.t('Entreprise')}
                        </p>
                        <TextFieldComponent
                            sx={{
                                '& > :not(style)': { borderRadius: '8px' },
                            }}
                            style={{width: '100%'}}
                            className="In1"
                            placeholder={i18n.t('Ajouter une entreprise')}
                            value={entrepriseName}
                            onChange={(event) => { SetEntrepriseName(event.target.value); }}
                        />
                    </div>
                    <div className='f5'>
                        <div className='f51'>
                            <p className='Titlef11'>
                                {i18n.t('Date de début souhaitée')}
                            </p>
                            <DatePickerComponent
                                label={i18n.t('Date de début souhaitée')}
                                value={dateDebutMission}
                                onChange={(newValue) => {
                                    setDateDebutMission(newValue);
                                }}
                                width={'100%'}
                            />
                        </div>
                        <div className='f52'>
                            <p className='Titlef11'>
                                {i18n.t('Date de publication')}
                            </p>
                            <DatePickerComponent
                                label={i18n.t('Date de publication')}
                                date={datePublication}
                                setDate={(newValue) => {
                                    setDatePublication(newValue);
                                }}
                                width={'100%'}
                            />
                        </div>
                    </div>
                    <div className='Box2Filter'>
                        <Button
                            variant="contained"
                            type='submit'
                            style={{ ...buttonStylesBlue(false), ...{ marginBottom: '40px',width:device=='desktop'?'auto':'100%'} }}
                            onClick={(e) => {
                                e.preventDefault();
                                handleAdvancedSearchAO();
                                handleCLoseAdvancedAOSearch();
                            }}
                        >
                            {i18n.t('Rechercher')}
                        </Button>
                    </div>
                </div>
            </form>
        </Dialog>
    );
}

export default AoAdvancedSearchDialog;